<template>
  <div>
    <header-group>
    </header-group>
    <div>
      <img src="../assets/1639745877778799.jpg" style="width: 100%; display:block">
    </div>
    <breadcrumb :breadcrumbs=breadcrumbs :button="button">
    </breadcrumb>

    <div class="index-news">
      <div class="index-title">
        <p class="t1" style="color: black;">执享信息</p>
        <div class="displayF" style="margin-top: 15px">
          <div style="background: #ef801a; height: 2px;width: 54px;top: 50%; right: 50%"></div>
        </div>
        <div class="grid-container">
          <div v-for="(item, i) in contentImgData" :key="i" class="grid-item">
            <industry-consulting :img="item">
            </industry-consulting>
          </div>
        </div>
      </div>
      <page></page>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import HeaderGroup from "@/components/HeaderGroup.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Bottom from "@/components/Bottom.vue";
import Page from "@/components/page.vue";
import IndustryConsulting from "@/components/IndustryConsulting.vue";

export default {
  name: 'industry',
  components: {IndustryConsulting, Page, Bottom, Breadcrumb, HeaderGroup},
  data() {
    return {
      breadcrumbs: [{name: '首页', path: '/'}, {name: '行业咨询（付费5元查看）', path: '/industry'}],
      button: [],
      contentImgData: [
        {
          img: require("@/assets/biaoge.jpg"),
          title: "赋能煤炭货运数字化的这一年，大数据都看到了什么？",
          content: "  根据5个省份的月度煤炭运输量数据表现趋势来看，内蒙古、山西、陕西三地均在2020年9月开始出现上涨趋势，主要是受供暖季对煤炭需求骤增的影响。   下面我们将重点放在内蒙古，从公路运输重量、煤炭运价、运煤车辆数等多个维度来看下内蒙古2020年整体的..."
        },    {
          img: require("@/assets/1_1.jpg"),
          title: "内蒙古走访见闻：数字化技术到底给煤炭流通带来什么？",
          content: "  「以前一天最多跑一趟，去了电厂还得排队几个小时甚至一整天，而现在 G7 数字甩箱模式推出应用后，问题迎刃而解。我拉活也更省心、省事，一天可以跑两三趟，收入也比以前增加了。」   「你能相信吗？这么大的运转中心，包括智能磅房在内的多个环节实现了无人..."
        },    {
          img: require("@/assets/1_2.jpg"),
          title: "小程序实现物流信息（进度展示）",
          content: " 其实可以把整体拆分成两大块，分别是最上方：物流详情，下方：物流信息；最上方实现起来比较简单，就不多赘述，主要跟大家说一下下面的实现思路，下面我又将它们分成了左边和右边两个大块，左边是进度的竖线展示，右边是物流文字信息展示，其中有两个点需要注意，首先..."
        },
        {
          img: require("@/assets/1_3.jpg"),
          title: "物联网浪潮席卷物流业的进化力样本",
          content: "  G7的指导思想是为上下游生态合作伙伴，提供具有行业场景落地能力的综合物联网技术。简要而言，这些新技术主要聚焦于三个方向：安全保险、智能装备和数字化结算。   物联网技术使能垂直行业的速度正在加快。在产业细分市场，如物流行业，在提高企业运营效率的同..."
        },    {
          img: require("@/assets/1_4.jpg"),
          title: "当AIoT成为商业基础设施，智慧物流路在何方？",
          content: "  我一直觉得，倘若文明有衡量标尺，那么永远在追求用最低成本，最高效率，将物体从 A 点移到 B 点的物流，一定是其中之一。   嗯，从人类真正意义上的第一个发明轮子开始，到驾驭马匹，开凿大运河，开启大航海，再到 100 多年前，铁路，汽车与飞机的集..."
        },    {
          img: require("@/assets/1_5.jpg"),
          title: "java对接物流系统api详解",
          content: " 合作商编码 companyId = kfpttestCode #合作商key key = kfpttestkey== #中通物流-创建订单api createOrderUrl = http://58.40.16.122:8080/OpenOrder..."
        },
        {
          img: require("@/assets/1_6.png"),
          title: "在中国速度下，公路货运的安全管理体系该如何完善？",
          content: " 改革开放以来，我国在铁路、公路、桥梁等各大领域的发展速度令人瞩目，一次次用速度与技术向世界诠释了什么是“中国速度”，其中包括我国的公路运输水平，尤其是高速公路运输总里程已经跃居世界第一。然而，在公路硬件这一“经济基础”的急剧增长下，公路货运的“上层..."
        },    {
          img: require("@/assets/1_7.jpg"),
          title: "Android 简单实现订单模块类APP的物流详情页",
          content: " 再次介绍一个特别好用的适配器 :BaseRecyclerViewAdapterHelper  首先导入依赖: //封装了RecyclerView自带的Adapter compile ‘com.github.CymChad:BaseRecyclerV..."
        },    {
          img: require("@/assets/1_8.jpg"),
          title: "Python 实现快递物流信息查询",
          content: " 这里我对查询做了控制,每次查询之后就回保存物流信息到数据库 (如果有redis等缓存服务器的话,最好是保存在缓存服务器里面), 如果是半小时内重复查询就返回数据库或缓存中的物流信息,因为物流信息没那么快跟新,没必要一直去查,要花钱的,时间间隔可以大..."
        },
      ]
    }
  }


}

</script>
<style scoped>

.index-news {
  padding: 10px 0 70px 0;
  background: white;
}

.index-title {
  padding: 60px 0;
  text-align: center;
  align-items: center;
  position: relative;
  line-height: 30px
}

.displayF {
  display: flex;
  justify-content: center;
}

.t1 {
  color: #333;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 两列 */
  grid-template-rows: repeat(3, 1fr); /* 两行 */
  gap: 20px; /* 项目间距 */
  max-width: 1000px; /* 控制整体宽度 */
  margin: 0 auto; /* 水平居中 */
  padding: 20px; /* 内边距 */
}


.grid-item {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden; /* 防止内容溢出 */
}

@media (max-width: 768px) {
  .grid-container {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
  }
}
</style>